<template>

</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive, markRaw,
  h, defineComponent, toRaw,
} from 'vue';
import store from '@/store';
import { isNull, dayjs, message, vueCreateAppInit } from '@/utils/js/initVariable';


import CustomLocaleControl from '@/views/Home/component/ManagePanel/components/WorkSpace/components/WorkSpaceData/components/CustomLocaleControl';

import SvgIcon from '@/components/SvgIcon';

// props
const props = defineProps({
  
});
// emit
const emit = defineEmits([
  
]);

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{
  mapEventInit();
  store.commit('isCustomLayerChange', true);
});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{
  layerGroupClose();
  mapEventClose();
  store.commit('isCustomLayerChange', false);
});

const homeMap = computed(()=> store.getters['getHomeMap'] ),
      map = toRaw(homeMap.value),
      layerGroup = L.featureGroup().addTo(map),
      layerGroupClose = ()=>{
        map.removeLayer(layerGroup);
      },
      layerGroupClear = ()=>{
        layerGroup.clearLayers();
      }

const mapEventClose = ()=>{
  map.off(L.Draw.Event.DRAWSTOP);
}

const mapEventInit = ()=>{
  map.on(L.Draw.Event.DRAWSTOP, event=>{
    // console.log(event);
    if(!event.layer)return;
    const layer = event.layer,
          bounds = layer.getBounds && layer.getBounds();
    layer.options['layerType'] = event['layerType'];
    // console.log(bounds, layer.getLatLngs());
    if(!bounds.isValid()){
      message('无效区域', 2);
      return;
    }
    customLocaleControlInit(layer, {});
    layerGroup.addLayer(layer);
  })
}

const customLocaleControlInit = (layer, target)=>{
  // console.log(layer);
  const bounds = layer.getBounds();
  const layerClick = (event)=>{
    const icon = controlMarker && controlMarker._icon;
    if(!icon)return;
    const display = icon.style.display;
    if(display == 'none'){
      icon.style.display = 'unset';
    }else{
      icon.style.display = 'none';
    }
  }
  const app = vueCreateAppInit(CustomLocaleControl, {
    target,
    layer,
    onLayerDelete: ()=>{
      layerGroup.removeLayer(layer);
    },
    layerGroup: layerGroup,
    // workSpace: props.workSpace,
    layerClick,
  });

  const controlMarker = L.marker(bounds.getNorthEast(),{
    icon: L.divIcon({
      iconAnchor: [-5, 0],
    }),
    // interactive: false,
  }).on({
    remove: event=>{
      app.unmount();
    }
  }).addTo(layerGroup);
  nextTick(()=>{
    const icon = controlMarker._icon;
    if(icon){
      icon.style.display = 'none';
      app.mount(icon);
    }
  })
  layer.on({
    remove: event=>{
      layerGroup.removeLayer(controlMarker);
    }
  })

}
</script>

<style lang='less'>

</style>

<style lang='less' scoped>

</style>